module.exports = __webpack_public_path__ + "a57d5c465bf873c6a1d69a367cdfb495.gif";